module.exports = __webpack_public_path__ + "img/img_no4.ccf5cc84.png";